import React from "react";
import styles from "./style.module.css";
import FlatButtons from "../../components/FlatButton/FlatButton";
import Typography from "../../components/Typography/Typography";
import { AboutDescriptionImage } from "../../assets/webp";
import { useNavigate } from "react-router";
import AnimatedButton from "../../components/AnimatedButton";

export const AboutDescription: React.FC = () => {
  const navigate = useNavigate()
  return (
    <div className={styles.whoWeAreContainer}>
      <section className={styles.whoWeAreSection}>
        
        <div className={styles.leftColumn}>
          <Typography
            variant="heading2"
            fontFamily="satoshi"
            weight="bold"
            className={styles.heading}
          >
            Who We Are
          </Typography>

          <Typography
            variant="bodyRegular"
            fontFamily="satoshi"
            weight="regular"
            className={styles.description}
          >
            OpenX is a digital platform that brings your product to life in
            immersive 3D stores. Product is showcased in rich virtual spaces,
            while audiences can explore stories, visuals, and culture from
            anywhere using a phone, computer, or VR headset. We make it radically
            simple for creators to build and launch their own virtual store
            without friction.
          </Typography>

          <AnimatedButton
          variant="primary"
          className={styles.ctaButton}
          onClick={() => {navigate("/create-store")}}
          >
            <Typography
              variant="buttonText"
              fontFamily="satoshi"
              weight="bold"
              size="base"
              className={styles.ctaText}
            >
              Create Store
            </Typography>
          </AnimatedButton>

          <img
            src={AboutDescriptionImage}
            alt="Gallery"
            className={styles.bottomImage}
          />
        </div>

        <div className={styles.rightColumn}>
          <Typography
            variant="bodyRegular"
            fontFamily="satoshi"
            weight="regular"
            className={styles.darkBoxText}
          >
            At OpenX, we believe African art deserves a stage as bold and
            dynamic as the stories it tells.<br /> Born at the intersection of culture
            and technology, OpenX exists to reimagine how people discover,
            experience, and share African creativity. We’re building more than
            just a platform, we’re building a movement. One that empowers artists
            to turn their works into immersive, interactive galleries, and
            enables anyone, anywhere, to explore them with ease.
            <br /><br />
            Our vision is to democratize access to art and give African creators
            the tools to own their space, build their audience, and showcase
            their heritage on a global scale.<br /> OpenX is not just about viewing art
             it’s about stepping into it.
          </Typography>
        </div>
      </section>
    </div>
  );
};
